<div class="layout-footer">BakerStreet ({{ buildVersion }} - {{ environment }}) - RTS Digital - RTS 2024 &copy;</div>
